// ============================================
// Asset Image Helper
// ใช้สำหรับจัดการรูปภาพของสินทรัพย์
// ============================================

/**
 * ดึง URL ของรูปสินทรัพย์
 * @param {string} symbol - Symbol ของสินทรัพย์ (เช่น BTC, ETH, XAU)
 * @param {string} fallback - รูปสำรอง (ถ้ามี)
 * @returns {string} URL ของรูปภาพ
 */
export const getAssetImage = (symbol, fallback = null) => {
  if (!symbol) return fallback || '/images/assets/default.svg';
  
  // แปลง symbol เป็นตัวพิมพ์ใหญ่
  const symbolUpper = symbol.toUpperCase();
  
  // Mapping สำหรับสินทรัพย์ที่อาจมีชื่อไฟล์แตกต่าง (case-insensitive handling)
  // รองรับทั้งตัวพิมพ์เล็กและใหญ่ตามชื่อไฟล์จริงที่มี
  const imageMap = {
    'XAU': 'gold.png', // ไฟล์จริงคือ gold.png (ตัวพิมพ์เล็ก)
    'OIL': 'OIL.png'    // ไฟล์จริงคือ OIL.png (ตัวพิมพ์ใหญ่)
  };
  
  // ใช้ชื่อไฟล์จาก map ถ้ามี มิฉะนั้นใช้ชื่อตาม symbol (ตัวพิมพ์ใหญ่)
  const fileName = imageMap[symbolUpper] || `${symbolUpper}.png`;
  
  // ส่งคืน path ของรูป
  return `/images/assets/${fileName}`;
};

/**
 * ดึง URL ของรูป banner
 * @param {number} bannerId - ID ของ banner (1-3)
 * @returns {string} URL ของรูปภาพ
 */
export const getBannerImage = (bannerId) => {
  return `/images/banners/banner${bannerId}.png`;
};

/**
 * ตรวจสอบว่ามีรูปภาพหรือไม่
 * @param {string} imageUrl - URL ของรูปภาพ
 * @returns {Promise<boolean>} มีรูปหรือไม่
 */
export const checkImageExists = (imageUrl) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = imageUrl;
  });
};

/**
 * Component สำหรับแสดงรูปสินทรัพย์พร้อม fallback
 */
export const AssetImage = ({ symbol, name, className = '', size = 50 }) => {
  const imageUrl = getAssetImage(symbol);
  
  const handleError = (e) => {
    // ซ่อนรูปที่โหลดไม่ได้
    e.target.style.display = 'none';
    // แสดง placeholder
    if (e.target.nextSibling) {
      e.target.nextSibling.style.display = 'flex';
    }
  };
  
  return (
    <div className={`asset-image ${className}`} style={{ width: size, height: size }}>
      <img 
        src={imageUrl} 
        alt={name || symbol}
        onError={handleError}
      />
      <div className="asset-placeholder" style={{ display: 'none' }}>
        {symbol?.charAt(0)}
      </div>
    </div>
  );
};

export default {
  getAssetImage,
  getBannerImage,
  checkImageExists,
  AssetImage
};
